import { useCallback, useMemo, useState } from "react";
import { Grid } from "@mui/material"; //Button
import { useSelector, useDispatch } from "react-redux";
import { updatePairingEditor } from "src/redux/actions/CrewSchedule/CrewSchedule.Actions";
import { IRootState } from "src/redux/reducers/CombinedReducers";
import { IPosition, IFullPairingPosition, OpenFlyingStatusType } from "@vmosolutions/oc-interfaces";
import { SelectField } from "../../../../FormikComponents/SelectField";
import { TextField } from "../../../../FormikComponents/TextField";

interface IAddPairingPositionsProps {
  id: string;
  children?: any;
}

interface IPositionOption {
  label: string;
  value: IPosition;
}

export const AddPairingPositions = (props: IAddPairingPositionsProps): JSX.Element => {
  const positions = useSelector((state: IRootState) => state.structures.customerStructure.positions);
  const [positionValue, setPositionValue] = useState<IPositionOption | null>(null);
  const [numPositions, setNumPositions] = useState<number>(1);
  const storedPairing = useSelector((state: IRootState) => state.crewSchedule.pairingEditors[props.id]);
  const dispatch = useDispatch();
  const positionOptions = useMemo(() => {
    return positions
      .sort((a, b) => a.displayOrder - b.displayOrder)
      .map((position: IPosition) => {
        //TODO Assigned this default open flying type in the structures directly.
        const updatedPosition = { openFlyingStatus: OpenFlyingStatusType.Closed, ...position };
        return { value: updatedPosition, label: position.description };
      });
  }, [positions]);

  const addNewPosition = useCallback(
    (positionValue: IPositionOption): void => {
      if (isNaN(numPositions)) {
        return;
      }

      const newPositionsArr: IFullPairingPosition[] = [];
      for (let i = 0; i < numPositions; i++) {
        newPositionsArr.push({
          position: positionValue.value,
          crew: null,
        });
      }
      const positions = [...storedPairing.positions, ...newPositionsArr];
      dispatch(updatePairingEditor(props.id, { positions: positions }));
      setPositionValue(null); // reset selection tool
      setNumPositions(1); // reset count
    },
    [storedPairing, numPositions]
  );
  return (
    <Grid
      container
      sx={{
        marginBottom: "5px",
        "& .position_type, .position_count": {
          overflow: "none",
          "& .input_control label": {
            width: "auto",
          },
        },
        "& .position_type": { width: "200px !important" },
        "& .position_count": { width: "100px !important" },
      }}
    >
      <SelectField
        className="position_type"
        label={`Add Crew Slot${numPositions > 1 ? "s" : ""}`}
        name="position"
        options={positionOptions}
        onChange={(pos: IPositionOption) => {
          setPositionValue(pos);
          addNewPosition(pos);
        }}
        placeholder="Select..."
        menuPosition="fixed"
        closeMenuOnSelect={true}
        isClearable={true}
        maxMenuHeight={400}
        value={positionValue}
      />
      <TextField
        className="position_count"
        label="Count"
        name="numPositions"
        value={numPositions}
        onChange={(e: any) => {
          setNumPositions(e?.target?.value ? Math.abs(e.target.value) : 1);
        }}
        inputProps={{ min: "0", max: "5" }}
        placeholder="number of positions..."
        type="number"
      />
    </Grid>
  );
};
